import CrudRepository from './CrudRepository'
export default class CitiesRepository extends CrudRepository {
  constructor () {
    super('customerCare/api/city/all')
  }
}
